module.exports = __webpack_public_path__ + "images/3-big.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/3-big.png
 ** module id = 573
 ** module chunks = 0
 **/